import axios from 'axios'
import { calls } from '../utils/calls.js'

export const setSelectedKitStyle = (style, nameOfStyle) => {
  return (dispatch) => {
    dispatch({
      type: 'SET_KIT_STYLE',
      payload: { style: style, nameOfStyle: nameOfStyle },
    })
  }
}
export const setSelectedKitSize = (size, nameOfSize) => {
  return (dispatch) => {
    dispatch({
      type: 'SET_KIT_SIZE',
      payload: { size: size, nameOfSize: nameOfSize },
    })
  }
}
export const setSelectedKitFabrics = (fabricsSet, fabricsDirection) => {
  return (dispatch) => {
    dispatch({
      type: 'SET_KIT_FABRICS',
      payload: { fabricsSet: fabricsSet, fabricsDirection: fabricsDirection },
    })
  }
}
export const setSelectedKitFillings = (fillingsSet) => {
  return (dispatch) => {
    dispatch({
      type: 'SET_KIT_FILLINGS',
      payload: { fillingsSet: fillingsSet },
    })
  }
}
export const setSelectedKitCordingFabrics = (cordingFabricsSet) => {
  return (dispatch) => {
    dispatch({
      type: 'SET_KIT_CORDING_FABRICS',
      payload: { cordingFabricsSet: cordingFabricsSet },
    })
  }
}
export const setSelectedKitQty = (kitQty) => {
  return (dispatch) => {
    dispatch({
      type: 'SET_KIT_QTY',
      payload: { kitQty: kitQty },
    })
  }
}

export const getKits = (userId) => {
  return new Promise((resolve, reject) => {
    return axios(calls.getKits(userId))
      .then((res) => {
        resolve(res)
      })
      .catch((err) => {
        reject(err)
      })
  })
}
